/* eslint-disable */
import React, { useRef, useState } from 'react';
// import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-google';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, redirect, useNavigate } from 'react-router-dom';

import { getPublicFile } from '@/store/files/actions';
import { login, registerUser, restoreUser, updateLoginEmpty } from '@/store/login/actions';

import { Flex, Spin } from 'antd';

import AuthorizationPage from './AuthorizationPage';
import AuthorizationPageFail from './AuthorizationPageFail';
import LoginFailure from './LoginFailure';
import LoginOauth from './LoginOauth';
import OAUTHSuccess from './OAUTHSuccess';
import RecoveryPage from './RecoveryPage';
import RecoveryPageData from './RecoveryPageData';
import RecoveryPageSuccess from './RecoveryPageSuccess';
import RegistrationPage from './RegistrationPage';
import RegistrationPageData from './RegistrationPageData';
import RegistrationPageSuccess from './RegistrationPageSuccess';

import { subscribeDevice } from '@/utils/pushManager';
import SSOSucces from '@shared/components/Login/SSOSucces';
import { useLocalFileByUUID } from '@shared/hooks/localFiles';
import useIsMobile from '@shared/hooks/useIsMobile';
import { AUTH_TYPES } from '@shared/pages/Login/constants';
import AuthorizationMobile from '@shared/pages/Login/Mobile/AuthorizationMobile';
import ConfirmAuthMobile from '@shared/pages/Login/Mobile/ConfirmAuthMobile';
import ConfirmRecoverMobile from '@shared/pages/Login/Mobile/ConfirmRecoverMobile';
import ConfirmRegisterMobile from '@shared/pages/Login/Mobile/ConfirmRegisterMobile';
import RecoveryMobile from '@shared/pages/Login/Mobile/RecoverMobile';
import RegisterMobile from '@shared/pages/Login/Mobile/RegisterMobile';
import AuthSSOLogin from '@shared/pages/Login/SAP/AuthSSOLogin';
import { selectCompany } from '@shared/store/company/selectors';
import { isAbsoluteCompany, isTDCompany } from '@shared/utils/domainCompanyId';

import store from '@/store';
import classNames from 'classnames';
import get from 'lodash/get';
import includes from 'lodash/includes';

import css from './Login.module.scss';

import loginImageMob from '@/assets/images/login_image_mob.png';
import loginImage from '@/assets/images/login_image_new.png';
import loginImageAbsolut from '@/assets/images/loginImageAbsolut.png';
import loginImageTD from '@/assets/images/loginImageTD.png';
import logoDefault from '@/assets/images/logo_default.png';

const getCurrentProvider = company => {
  let currentCompany = company.providers.find(
    provider => provider.type === AUTH_TYPES.OAUTH || provider.type === AUTH_TYPES.SAP
  );

  if (currentCompany) return currentCompany;

  if (!company?.hasIpRestriction) {
    return company.providers.find(provider => !provider.external);
  }

  return company.providers.find(provider => provider.external);
};

const loaderAuthorizationPage = async () => {
  const url = new URL(window.location.href);
  const companyInfo = store.getState().company.company;

  const isMobileRecovery = url.pathname.includes('/user-login/mobile-recovery');
  const hasMobileProvider = companyInfo?.providers.find(provider => provider.type === AUTH_TYPES.MOBILE);

  if (isMobileRecovery && hasMobileProvider) {
    return null;
  }

  if (companyInfo) {
    const currentProvider = getCurrentProvider(companyInfo);

    if (currentProvider.type === AUTH_TYPES.OAUTH && !isDevMode) {
      return redirect('/user-login/oauth');
    }
  }
  return null;
};

const loaderOAUTHAuthorizationPage = async () => {
  if (store.getState().company?.company) {
    const currentProvider = getCurrentProvider(store.getState().company?.company);

    if (currentProvider.type !== AUTH_TYPES.OAUTH && !isDevMode) {
      return redirect('/user-login');
    }
  }
  return null;
};

const loaderSAPAuthorizationPage = async () => {
  if (store.getState().company?.company) {
    const currentProvider = getCurrentProvider(store.getState().company?.company);
    if (currentProvider.type !== 'SAP') return redirect('/user-login/');
  }
  return null;
};

export const loginChildren = [
  {
    index: true, // корневой индекс
    Component: AuthorizationPage,
    loader: loaderAuthorizationPage,
  },
  {
    path: 'auth',
    Component: AuthorizationPage,
    loader: loaderAuthorizationPage,
  },
  {
    path: 'oauth',
    Component: document.location.search.includes('root') ? AuthorizationPage : LoginOauth,
    loader: loaderOAUTHAuthorizationPage,
  },
  {
    path: 'mobile',
    Component: document.location.search.includes('root') ? AuthorizationPage : AuthorizationMobile,
    // loader: loaderAuthorizationPage,
  },
  {
    path: 'mobile/verify/:id',
    Component: ConfirmAuthMobile,
    // loader: loaderAuthorizationPage,
  },
  {
    path: 'mobile-registration',
    Component: RegisterMobile,
    loader: loaderAuthorizationPage,
  },
  {
    path: 'mobile-registration/:id',
    Component: ConfirmRegisterMobile,
    loader: loaderAuthorizationPage,
  },
  {
    path: 'mobile-recovery/:id',
    Component: ConfirmRecoverMobile,
    // loader: loaderAuthorizationPage,
  },

  {
    path: 'success',
    Component: OAUTHSuccess,
    loader: loaderOAUTHAuthorizationPage,
  },
  {
    path: 'auth-fail',
    Component: AuthorizationPageFail,
    // loader: loaderAuthorizationPage,
  },
  {
    path: 'failure',
    Component: LoginFailure,
    // loader: loaderAuthorizationPage,
  },
  {
    path: 'registration',
    Component: RegistrationPage,
    loader: loaderAuthorizationPage,
  },
  {
    path: 'recovery-success',
    Component: RecoveryPageSuccess,
    // loader: loaderAuthorizationPage,
  },
  {
    path: 'recovery-page-data',
    Component: RecoveryPageData,
    // loader: loaderAuthorizationPage,
  },
  {
    path: 'recovery',
    Component: RecoveryPage,
    loader: loaderAuthorizationPage,
  },
  {
    path: 'mobile-recovery',
    Component: RecoveryMobile,
    // loader: loaderAuthorizationPage,
  },
  {
    path: 'registration-page-data',
    Component: RegistrationPageData,
    // loader: loaderAuthorizationPage,
  },
  {
    path: 'registration-success',
    Component: RegistrationPageSuccess,
    loader: loaderAuthorizationPage,
  },

  {
    path: 'sap', // для авторизации по SAP
    Component: document.location.search.includes('root') ? AuthorizationPage : AuthSSOLogin,
    loader: loaderSAPAuthorizationPage,
  },
  {
    path: 'lks', // для перехода из ЛК Северсталь чтобы отловить параметр ссо тикет
    Component: SSOSucces,
    // loader: loaderOAUTHAuthorizationPage,
  },
  {
    path: '*',
    loader: async () => {
      if (store.getState().company?.company) {
        const currentProvider = getCurrentProvider(store.getState().company.company);

        if (currentProvider.type === AUTH_TYPES.OAUTH) {
          redirect('/user-login/oauth');
        }

        if (currentProvider.type === 'SAP') {
          redirect('/user-login/sap');
        }

        if (currentProvider.type === 'MOBILE') {
          redirect('/user-login/mobile');
        }
      }
      return redirect('/user-login');
    },
  },
];

export const loginLoader = async ({ request }) => {
  const hasToken = localStorage.getItem('authorizationToken');

  if (hasToken || store.getState().users.currentUser) {
    return redirect('/');
  }

  const url = new URL(request.url);
  const searchParams = url.searchParams;
  const registerParam = searchParams.get('register');
  const restoreParam = searchParams.get('restore');

  if (registerParam) {
    searchParams.delete('register');
    return redirect(`/user-login/registration-page-data?token=${registerParam}`);
  }

  if (restoreParam) {
    searchParams.delete('restore');
    return redirect(`/user-login/recovery-page-data?token=${restoreParam}`);
  }

  return null;
};

export default function LoginLayout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const captchaDemo = useRef(null);

  const [isEntering, setEntering] = useState(false);
  const { company, providersTypes } = useSelector(selectCompany);
  // const { initCookies } = useAuthorizationCookies();

  const [state, changeState] = useState({
    password: '',
    username: '',
    readInfo: false,
    render: true,
    verifyCaptcha: false,
    isAuthStarted: JSON.parse(localStorage.getItem('isAuthStarted')),
    typeRecaptcha: null,
  });

  const setState = item => changeState({ ...state, ...item });

  const toLogin = (password, username, verifyCaptcha) => {
    setEntering(true);
    dispatch(
      login(
        password,
        username,
        verifyCaptcha,
        response => {
          localStorage.setItem('authorizationToken', response.accessToken);
          localStorage.setItem('refreshToken', response.refreshToken);
          localStorage.setItem('expiresIn', response.expiresIn);
          localStorage.setItem('expiresTime', response.expiresIn * 1000 + Date.now());

          // initCookies(response.accessToken, response.refreshToken, response.expiresIn * 1000 + Date.now());
          subscribeDevice();

          const redirect = localStorage.getItem('currentRedirect') ? localStorage.getItem('currentRedirect') : '/';
          navigate(redirect);
        },
        () => setEntering(false)
      )
    );
  };

  const loginPageImage = () => {
    if (isTDCompany(company)) {
      return loginImageTD;
    }

    if (isAbsoluteCompany(company)) {
      return loginImageAbsolut;
    }

    return loginImage;
  };

  const onLoadRecaptcha = () => {
    if (captchaDemo.current) {
      if (window.grecaptcha) {
        // костыль, т.к. у невидимой капчи нет события по закрытию фрейма с картинками
        const callback = mutationsList => {
          if (!state.verifyCaptcha) {
            return;
          }
          for (const mutation of mutationsList) {
            const isIframe = includes(
              get(mutation, 'target.children[1].children[0].src', ''),
              'https://www.google.com/recaptcha/api2/bframe'
            );
            const oldVisible = includes(get(mutation, 'oldValue', ''), 'visibility: visible');
            const newVisible = get(mutation, 'target.style.visibility', '') === 'hidden';
            if (isIframe && oldVisible && newVisible) {
              setState({ verifyCaptcha: false });
              return;
            }
          }
        };

        const observer = new MutationObserver(callback);
        observer.observe(document.body, {
          attributes: true,
          attributeOldValue: true,
          subtree: true,
        });
      }
      captchaDemo.current.reset();
      captchaDemo.current.execute();
    }
  };

  const verifyCallback = recaptchaToken => {
    switch (state.typeRecaptcha && state.typeRecaptcha.type) {
      case 'register':
        dispatch(
          registerUser(state.typeRecaptcha.email, state.typeRecaptcha.password, recaptchaToken, () => {
            navigate('/user-login/registration-success');
            setState({ verifyCaptcha: false });
          })
        );
        break;
      case 'restore':
        dispatch(
          restoreUser(state.typeRecaptcha.email, recaptchaToken, () => {
            navigate('/user-login/recovery-success');
            setState({ verifyCaptcha: false });
          })
        );
        break;
      case 'login':
        toLogin(state.typeRecaptcha.password, state.typeRecaptcha.username, recaptchaToken);
        setState({ verifyCaptcha: false });
        break;
      default:
        break;
    }
  };

  const registerUserRecaptcha = (email, password, newsletter) => {
    setState({ verifyCaptcha: true });
    setState({
      typeRecaptcha: { type: 'register', email, password },
    });
    localStorage.setItem('isAuthStarted', 'true');
    if (!company?.providers[0].external && company?.hasCaptcha) {
      // loadReCaptcha();
      captchaDemo.current && captchaDemo.current.reset();
      captchaDemo.current && captchaDemo.current.execute();
    } else {
      const onSuccess = () => {
        navigate('/user-login/registration-success');
        setState({ verifyCaptcha: false });
      };
      const onError = () => {
        setState({ verifyCaptcha: false });
      };

      if (typeof newsletter !== 'undefined') {
        dispatch(registerUser(email, password, newsletter, '', onSuccess, onError));
      } else {
        dispatch(registerUser(email, password, undefined, '', onSuccess, onError));
      }
    }
  };

  const restoreUserRecaptcha = email => {
    setState({ verifyCaptcha: true });
    setState({ typeRecaptcha: { type: 'restore', email } });
    localStorage.setItem('isAuthStarted', 'true');
    if (!company?.providers[0].external && company?.hasCaptcha) {
      // loadReCaptcha();
      captchaDemo.current.reset();
      captchaDemo.current.execute();
    } else {
      dispatch(
        restoreUser(
          email,
          '',
          () => {
            navigate('/user-login/recovery-success');
            setState({ verifyCaptcha: false });
          },
          () => setState({ verifyCaptcha: false })
        )
      );
    }
  };

  const loginUserRecaptcha = (password, username) => {
    setState({ verifyCaptcha: true });
    setState({
      typeRecaptcha: { type: 'login', password, username },
    });
    localStorage.setItem('isAuthStarted', 'true');
    if (!company.providers[0]?.external && company.hasCaptcha) {
      // loadReCaptcha();
      captchaDemo.current.reset();
      captchaDemo.current.execute();
    } else {
      toLogin(password, username);
      setState({ verifyCaptcha: false });
    }
  };

  const captcha = el => {
    captchaDemo.current = el;
  };

  const [imageLogo, isLoadingImageLogo] = useLocalFileByUUID(company?.logo, {
    publish: true,
    defaultImg: logoDefault,
  });

  const [imageBackgroundLogin, isLoadingBackgroundLogin] = useLocalFileByUUID(company?.background, {
    isDefaultNull: true,
    publish: true,
  });

  const [isMobile] = useIsMobile(769);

  return (
    <Spin spinning={isEntering} size='large' className={css['LoginPage']}>
      {company?.hasCaptcha && (
        <div className={css['LoginPage-captcha']}>
          {/* <ReCaptcha
            ref={captcha}
            size='invisible'
            hl='ru'
            render='explicit'
            sitekey='6Lfd7LMUAAAAAP8O6maJjJj4c09wPyk6INImt9-i'
            onloadCallback={onLoadRecaptcha}
            verifyCallback={verifyCallback}
          /> */}
        </div>
      )}
      <>
        <Flex vertical={isMobile} align='center' justify='center' className={css.LoginContent}>
          <Flex
            vertical
            align='center'
            justify='center'
            className={classNames(css['LoginPage-card'], {
              [css['LoginPage-card-abs']]: isAbsoluteCompany(company),
            })}
          >
            <Outlet
              context={{
                getPublicFile: getPublicFile,
                registerUserRecaptcha: registerUserRecaptcha,
                restoreUserRecaptcha: restoreUserRecaptcha,
                isAuthStarted: state.isAuthStarted,
                navigate: navigate,
                company: company,
                login: login,
                updateLoginEmpty: updateLoginEmpty,
                setEntering: setEntering,
                providersTypes: providersTypes,

                loginUserRecaptcha,
                imageBackgroundLogin,
                isLoadingBackgroundLogin,
                imageLogo,
                isLoadingImageLogo,
              }}
            />
          </Flex>
          <Flex className={css['LoginPage-image-box']} align='center' justify='center'>
            <img
              className={classNames(css['LoginPage-image'], {
                [css['LoginPage-image-abs']]: isAbsoluteCompany(company),
              })}
              src={loginPageImage()}
              alt='login'
            />
          </Flex>
        </Flex>
      </>
    </Spin>
  );
}
